export const TEXT = {
    please_email: "กรุณาระบุ Email Address",
    alltaxID: "ระบุ: เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี/เลขที่หนังสือเดินทาง",
    cardID: "ระบุ: เลขที่บัตรประชาชน/เลขประจำตัวผู้เสียภาษี",
    nocardID: "ระบุ: เลขที่หนังสือเดินทาง",
    company_name: "ระบุ: ชื่อบริษัท/ชื่อ-นามสกุล (ระหว่างชื่อนามสกุลเคาะ 1 วรรค)",
    phone: "ระบุ: เบอร์โทรศัพท์",
    not_data_customer: "ไม่พบข้อมูลผู้ซื้อในระบบ",
    warningABB: "สามารถค้นหาใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อไม่เกิน 10 รายการ",
    tpno: "TPNo.",
    receiptNo: "Receipt No.",
    confirmEtaxinvoice: "ยืนยันการออก E-TAX Invoice?",
    replace_cause: "ระบุสาเหตุการออกเอกสารใบทดแทน",
    not_name_replace: "ชื่อไม่ถูกต้อง",
    not_address_replace: "ที่อยู่ไม่ถูกต้อง",
    not_other_replace: "อื่นๆ โปรดระบุ",
    taxNumber_replace: "เลขที่ใบกำกับภาษีรูปแบบเต็ม",
    date_document: "วันที่ออกเอกสาร :",
    number_abb: "เลขที่ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ",

}